<template>
    <el-row type="flex" class="menu" v-show="list !== undefined && list.length > 0">
        <!--todo 選中狀態樣式加上 active-->
        <div v-for="(item, index) in list" :key="index"
             :class="['item', (activityItemName===item.name)? 'active':'']" @click="onClick(item)" >
            <img :src="(activityItemName===item.name)? item.selectIcon : item.icon">
            <span :style="{'font-size':(item.name.length > 3)?'12px':'14px'}">{{item.name}}</span>
        </div>
    </el-row>
</template>

<script>
export default {
    name: "QuickMenu",
    props: {
        list: { type:Array, default: Array.of([]) },  // list = [name:string, icon:string]
        defIcon: { type:String, default: '' },  // list = [name:string, icon:string]
    },
    data() {
        return {
            activityItemName: '',
        }
    },
    created() {

    },
    mounted() {

    },
    watch: {
        'defIcon': function () {
            this.activityItemName = this.defIcon;
        },
    },
    methods: {
        /** 點擊事件 */
        onClick: function(item) {
            this.activityItemName = item.name;
            //發送現在點到的 item名稱
            this.$emit('clickItem', item);
        }
    }
}
</script>